import { isUserLogin } from '@eureka/utils/account';

/**
 * 支持外观专利的受理局代码列表
 */
export const DesignPatentCountries = [
    'AE',
    'AL',
    'AP',
    'AR',
    'AT',
    'AU',
    'BA',
    'BG',
    'BN',
    'BR',
    'BX',
    'CA',
    'CH',
    'CN',
    'CO',
    'CR',
    'CS',
    'CU',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EA',
    'EE',
    'ES',
    'EU',
    'FI',
    'FR',
    'GB',
    'GE',
    'GR',
    'HK',
    'HR',
    'HU',
    'ID',
    'IE',
    'IL',
    'IN',
    'IS',
    'IT',
    'JO',
    'JP',
    'KE',
    'KH',
    'KR',
    'KZ',
    'LA',
    'LI',
    'LT',
    'LV',
    'MA',
    'MD',
    'ME',
    'MN',
    'MO',
    'MT',
    'MX',
    'MY',
    'NO',
    'NZ',
    'PE',
    'PH',
    'PL',
    'PT',
    'RO',
    'RS',
    'RU',
    'SA',
    'SE',
    'SG',
    'SI',
    'SK',
    'TH',
    'TN',
    'TR',
    'TW',
    'UA',
    'US',
    'VN',
    'WO'
];

/**
 * 单位MB
 */
export const MAX_FILE_SIZE = 4;

/**
 * 最大文件大小（字节）
 */
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE * 1024 * 1024;

/**
 * 文本输入最大字符长度
 */
export const MAX_TEXT_LENGTH = 500;

/**
 * 获取 Design FTO API URL 前缀
 */
export async function getDesignFtoApiUrlPrefix() {
    if (import.meta.env.DEV) {
        const useLocalApi = false;
        if (useLocalApi) {
            return 'http://127.0.0.1:8000/fto-image';
        }
    }
    const isLogin = await isUserLogin();
    const VITE_CORE_SEARCH_SERVICE_URI = import.meta.env.VITE_CORE_SEARCH_SERVICE_URI;
    if (!isLogin) {
        return `${VITE_CORE_SEARCH_SERVICE_URI}/public-share-image/fto-image`;
    }
    return `${VITE_CORE_SEARCH_SERVICE_URI}/fto-image-api/fto-image`;
}

/**
 * 生成Design FTO报告页面的URL
 * @param taskId 任务ID
 * @returns 报告页面的完整URL
 */
export function generateDesignFtoUrl(taskId: string): string {
    const baseUrl = import.meta.env.DEV ? 'http://localhost:5173' : '/ip/checking';
    return `${baseUrl}/#/design-fto?task_id=${taskId}`;
}

export const DESIGN_FTO_EVENT_TYPE = 'SS IP Image Search Agent';
